<template>
  <div>
    <!-- BEGIN: Account Menu -->
    <div class="intro-x dropdown">
      <div
        class="dropdown-toggle"
        role="button"
        aria-expanded="false"
      >
      {{ name == 'color' ? "Color" : (name == 'cut' ? "Cut" : (name == 'purity' ? "Purity" : (name == 'polish' ? "Polish" : (name == 'shape' ? "Shape" : (name == 'symmetry' ? "Symmetry" : (name == 'fluerocent' ? "Fluerocent" : (name == 'tension' ? "Tension" : (name == 'stone' ? "Stone" : (name == 'quality' ? "Quality" : ''))))))))) }} <ChevronDownIcon class="w-3 h-3" />
      </div>
      <div class="dropdown-menu w-32 max-h-48 overflow-y-auto overflow-x-hidden">
        <div
          class="dropdown-menu__content box"
        >
        <div class="p-1 flex items-center justify-start" v-for="(option, index) in options" :key="index">
          <input class="mx-2" type="checkbox" :id="index" :value="option.id" v-model="pagedata.selected">
          <label :for="index">{{ name == 'color' ? option.color_name : (name == 'cut' ? option.cut_name : (name == 'purity' ? option.purity_name : (name == 'polish' ? option.polish_name : (name == 'shape' ? option.shape_name : (name == 'symmetry' ? option.symmetry_name : (name == 'fluerocent' ? option.fluerocent_name : (name == 'tension' ? option.tension_name : (name == 'stone' ? option.stone_name : (name == 'quality' ? option.quality_name : ''))))))))) }}</label>

          </div>
        </div>
      </div>
    </div>
    <!-- END: Account Menu -->
    <!-- <div class="dropdown" @click="showDropdown">
      {{ name }} <ChevronDownIcon class="w-4 h-4"></ChevronDownIcon>
    </div>
    <div class="multiselect" v-if="pagedata.show">
      <ul>
        <li v-for="(option, index) in options" :key="index" class="flex items-center justify-around">
          <input type="checkbox" :id="index" :value="option.id" v-model="pagedata.selected">
          <label :for="index">{{ name == 'color' ? option.color_name : (name == 'cut' ? option.cut_name : (name == 'purity' ? option.purity_name : (name == 'polish' ? option.polish_name : (name == 'shape' ? option.shape_name : (name == 'symmetry' ? option.symmetry_name : (name == 'fluerocent' ? option.fluerocent_name : (name == 'tension' ? option.tension_name : option.stone_name))))))) }}</label>
        </li>
      </ul>
    </div> -->
  </div>
</template>
<script>
/* eslint-disable */
import { defineComponent, reactive, watch } from 'vue'
  export default defineComponent({
  props: ['options','name'],
  emits: ['getData','updatParameters','showNotification'],
  setup(props, {emit}) {
    const pagedata = reactive({
      show: false,
      selected: []
    })
    function showDropdown() {
      pagedata.show = !pagedata.show
    }
    watch(() => pagedata.selected, (currentValue) => {
      emit('onChecked', currentValue)
    })
    return {
      showDropdown,
      pagedata
    }
  }
  })
</script>
<style scoped>
.dropdown {
  cursor: pointer;
}

.multiselect {
  position: relative;

}
.multiselect ul {
    background: #fff;
    color: black;
    border: 1px solid #ddd;
    border-top: 0;
    border-radius: 0 0 3px 3px;
    left: 0px;
    padding: 4px 4px;
    position: absolute;
    top: 1rem;
    /* width: 50px; */
    list-style: none;
    max-height: 150px;
    overflow: auto;
  }
.overselect {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
